import { useRef } from "react";
import { motion } from "framer-motion";
import { IMG } from "../../data/site";
import { Eyebrow, Photo, Reveal, WordReveal, useParallax } from "./primitives";

const BENEFITS = [
  "A deeper connection with yourself",
  "Greater ease and comfort in your body",
  "More clarity and awareness in everyday life",
  "A greater capacity to navigate life's challenges",
  "More freedom from habitual patterns and reactions",
  "A deeper sense of presence and connection with others",
];

export default function Philosophy() {
  const ref = useRef(null);
  const y = useParallax(ref, ["-6%", "6%"]);
  return (
    <section id="philosophy" aria-labelledby="philosophy-title" data-testid="philosophy-section" className="relative scroll-mt-24 bg-ivory px-6 py-24 sm:px-8 lg:px-12 lg:py-40">
      <div className="mx-auto grid max-w-7xl gap-16 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-7">
          <Reveal>
            <Eyebrow>About my work</Eyebrow>
          </Reveal>
          <h2 id="philosophy-title" className="sr-only">About my work</h2>
          <WordReveal
            testid="philosophy-statement"
            text="Most people live in their heads — thinking, analyzing, pushing through life."
            className="mt-7 font-display text-[2.15rem] font-light leading-[1.12] text-ink sm:text-5xl lg:text-[3.6rem]"
          />
          <Reveal delay={0.1} className="mt-10 max-w-xl">
            <p className="text-base leading-relaxed text-ink-soft sm:text-lg">
              My work is about helping you come back into your body because when you're connected to your breath, your body and your awareness…everything changes.
            </p>
          </Reveal>
          <Reveal delay={0.1} className="mt-12">
            <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-ink-soft" data-testid="philosophy-benefits-intro">Through this work, you may begin to experience:</p>
          </Reveal>
          <ul className="mt-6 grid gap-x-10 border-t border-ink/10 sm:grid-cols-2" data-testid="philosophy-lines">
            {BENEFITS.map((l, i) => (
              <Reveal as="li" key={l} delay={0.15 + (i % 2) * 0.1 + Math.floor(i / 2) * 0.1} className="flex items-baseline gap-4 border-b border-ink/10 py-5 font-display text-xl italic leading-snug text-ink sm:text-[1.45rem]">
                <span aria-hidden className="mt-1 h-1.5 w-1.5 shrink-0 -translate-y-1 rounded-full bg-coral" />
                {l}
              </Reveal>
            ))}
          </ul>
        </div>

        <div ref={ref} className="relative lg:col-span-5 lg:pt-24">
          <Reveal y={40} className="relative overflow-hidden rounded-[2rem]">
            <div className="aspect-square overflow-hidden rounded-[2rem] bg-sand">
              <motion.div style={{ y }} className="h-[114%] w-full -translate-y-[7%]">
                <Photo img={IMG.meditate} sizes="(min-width:1024px) 40vw, 92vw" className="h-full w-full object-cover" data-testid="philosophy-image" />
              </motion.div>
            </div>
          </Reveal>
          <div aria-hidden className="absolute -bottom-8 -left-8 -z-0 hidden h-40 w-40 rounded-full border border-coral/40 lg:block" />
        </div>
      </div>
    </section>
  );
}
